import React, { Component } from "react";
import { connect } from "react-redux";
import EventOption from "components/Common/SelectEvent/EventOption";
import ToggleableSelect from "components/Common/Clauses/ToggleableSelect";
import { selectAccountUserEvents } from "reducers/account/userEvents";
import { checkIsValueDefinedAndValid } from "utils";

class SelectEvent extends Component {
  constructor(props) {
    super(props);

    this.selectEventRef = null;
  }

  setSelectEventRef = element => {
    this.selectEventRef = element;
  };

  render() {
    const { value, userEvents, onChange, readOnly } = this.props;

    const eventOptions = Object.values(userEvents || {}).filter(
      it => value === it.name || it.showInUI
    );

    if (
      checkIsValueDefinedAndValid(value) &&
      !eventOptions.find(event => event.name === value)
    ) {
      eventOptions.push({ value, name: value });
    }

    return (
      <div className="Select select-event-name" ref={this.setSelectEventRef}>
        <ToggleableSelect
          readOnlyContent={value}
          clearable={false}
          value={value}
          options={eventOptions.map(userEvent => {
            return {
              ...userEvent,
              label: userEvent.name,
              value: userEvent.name
            };
          })}
          optionRenderer={opt => (
            <EventOption event={opt} selectMenuRef={this.selectEventRef} />
          )}
          autosize={false}
          onChange={onChange}
          readOnly={readOnly}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userEvents: selectAccountUserEvents(state)
  };
}

export default connect(mapStateToProps)(SelectEvent);
